(function () {
  'use strict';

  /* ---- Elements ---- */
  const stickyBar = document.querySelector('[data-sticky-atc]');
  const drawer = document.querySelector('[data-sticky-drawer]');
  if (!stickyBar || !drawer) return;

  const IS_FI = false;

  const openBtn = stickyBar.querySelector('[data-sticky-open-drawer]');
  const backdrop = drawer.querySelector('[data-drawer-backdrop]');
  const closeBtn = drawer.querySelector('[data-drawer-close]');
  const atcBtn = drawer.querySelector('[data-drawer-atc-btn]');
  const atcText = drawer.querySelector('[data-drawer-atc-text]');
  const atcSpinner = drawer.querySelector('.satc-drawer__atc-spinner');
  const drawerPriceEl = drawer.querySelector('[data-drawer-price]');
  const stickyPriceEl = stickyBar.querySelector('[data-sticky-price]');

  /* ---- Cart drawer (teeman oma) ---- */
  const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

  /* ---- Variant data ---- */
  const productId = atcBtn ? atcBtn.dataset.productId : null;
  const variantsScript = document.getElementById('sticky-atc-variants-' + productId);
  const variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];

  /* ---- Original ATC btn + Bundle ATC btn ---- */
  const originalBtn = document.querySelector('.celestic-atc-btn') || document.querySelector('.product-form__submit');
  const bundleBtn = document.querySelector('.celestic-bundle__cta');

  /* Visibility state — start as hidden if button exists, so sticky stays hidden until observer fires */
  let originalBtnHidden = !originalBtn;
  let bundleBtnHidden = !bundleBtn;
  let nearFooter = false;

  function applyVisibility() {
    const show = originalBtnHidden && bundleBtnHidden && !nearFooter;
    stickyBar.classList.toggle('is-visible', show);
    stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  /* Watch both ATC buttons — hide sticky when either is visible */
  if ('IntersectionObserver' in window) {
    if (originalBtn) {
      new IntersectionObserver(function (entries) {
        originalBtnHidden = !entries[0].isIntersecting;
        applyVisibility();
      }, { threshold: 0 }).observe(originalBtn);
    }
    if (bundleBtn) {
      new IntersectionObserver(function (entries) {
        bundleBtnHidden = !entries[0].isIntersecting;
        applyVisibility();
      }, { threshold: 0 }).observe(bundleBtn);
    }
  }

  /* Footer proximity — hide sticky when footer is in view */
  const footerEl = document.querySelector('footer, .footer, [id*="footer"]');
  if (footerEl && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      nearFooter = entries[0].isIntersecting;
      applyVisibility();
    }, { rootMargin: '0px 0px 20px 0px', threshold: 0 }).observe(footerEl);
  } else if (footerEl) {
    function checkFooter() { nearFooter = footerEl.getBoundingClientRect().top < window.innerHeight + 20; }
    window.addEventListener('scroll', function () { checkFooter(); applyVisibility(); }, { passive: true });
    window.addEventListener('resize', function () { checkFooter(); applyVisibility(); }, { passive: true });
    checkFooter();
  }

  /* ---- Drawer open / close ---- */
  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const firstBtn = drawer.querySelector('.satc-drawer__size-btn:not(:disabled)');
    if (firstBtn) firstBtn.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    cursorClose.classList.remove('is-visible');
    if (openBtn) openBtn.focus();
  }

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  /* ---- Klikkaus drawerin ulkopuolelle sulkee sen ---- */
  drawer.addEventListener('click', function (e) {
    if (!e.target.closest('.satc-drawer__panel')) closeDrawer();
  });

  /* ---- Cursor-following X button on backdrop ---- */
  const cursorClose = document.createElement('button');
  cursorClose.className = 'satc-cursor-close';
  cursorClose.innerHTML = '&times;';
  cursorClose.setAttribute('aria-label', 'Sulje');
  cursorClose.setAttribute('type', 'button');
  document.body.appendChild(cursorClose);

  cursorClose.addEventListener('click', closeDrawer);

  backdrop.addEventListener('mouseenter', function () {
    if (drawer.classList.contains('is-open')) cursorClose.classList.add('is-visible');
  });

  backdrop.addEventListener('mouseleave', function () {
    cursorClose.classList.remove('is-visible');
  });

  var rafPending = false;
  var lastMouseX = 0, lastMouseY = 0;
  document.addEventListener('mousemove', function (e) {
    lastMouseX = e.clientX;
    lastMouseY = e.clientY;
    if (!rafPending) {
      rafPending = true;
      requestAnimationFrame(function () {
        cursorClose.style.left = lastMouseX + 'px';
        cursorClose.style.top = lastMouseY + 'px';
        rafPending = false;
      });
    }
  });

  /* ---- Size selection ---- */
  let selectedVariantId = atcBtn ? parseInt(atcBtn.dataset.variantId, 10) : null;

  function formatMoney(cents) {
    return Math.round(cents / 100) + '€';
  }

  function updateAtcButton(variantId) {
    const v = variants.find(function (x) { return x.id === variantId; });
    if (!v) return;
    selectedVariantId = variantId;
    if (atcBtn) atcBtn.dataset.variantId = variantId;
    const priceStr = formatMoney(v.price);
    if (atcBtn) atcBtn.disabled = !v.available;
    refreshAtcText();
    if (drawerPriceEl) drawerPriceEl.textContent = priceStr;
    if (stickyPriceEl) stickyPriceEl.textContent = priceStr;
  }

  /* ---- 48H badge: näkyy vain kun valittu koko on 48h (salama) -koko ---- */
  const drawerBadge48 = drawer.querySelector('.satc-drawer__badge--48h');
  const stickyBadge48 = stickyBar.querySelector('.sticky-atc__badge--48h');
  function refresh48hBadge() {
    if (!drawerBadge48 && !stickyBadge48) return;
    const show = !!drawer.querySelector('.satc-drawer__size-btn.is-active .satc-drawer__size-icon');
    if (drawerBadge48) drawerBadge48.style.display = show ? '' : 'none';
    if (stickyBadge48) stickyBadge48.style.display = show ? '' : 'none';
  }
  refresh48hBadge();

  drawer.querySelectorAll('.satc-drawer__size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      const grid = btn.closest('.satc-drawer__option-grid');
      grid.querySelectorAll('.satc-drawer__size-btn').forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
      refresh48hBadge();

      const allGroups = drawer.querySelectorAll('.satc-drawer__option-grid');
      const selectedOptions = [];
      allGroups.forEach(function (g) {
        const active = g.querySelector('.satc-drawer__size-btn.is-active');
        if (active) selectedOptions.push(active.dataset.optionValue);
      });

      const matched = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
      });
      if (matched) updateAtcButton(matched.id);
    });
  });

  /* ---- Upsell toggle + size selection ---- */
  let upsellEnabled = false;
  let upsellVariantId = null;

  const upsellToggle = drawer.querySelector('[data-upsell-toggle]');
  const upsellSizesPanel = drawer.querySelector('[data-upsell-sizes]');
  const upsellContainer = drawer.querySelector('[data-satc-upsell]');
  const upsellFixedPrice = upsellContainer && upsellContainer.dataset.upsellFixedPrice
    ? parseInt(upsellContainer.dataset.upsellFixedPrice, 10)
    : 0;
  const isBundleProduct = !!(upsellContainer && upsellContainer.hasAttribute('data-upsell-fixed-price'));
  const BUNDLE_DISCOUNT_CODE = (upsellContainer && upsellContainer.dataset.upsellIsLongsleeve) ? 'CELESTIC-LS-JEANS'
    : (upsellContainer && upsellContainer.dataset.upsellIsJeans) ? 'CELESTIC-JEANS'
    : (upsellContainer && upsellContainer.dataset.upsellIsSummerSet) ? 'CELESTIC-SUMMER'
    : (upsellContainer && upsellContainer.dataset.upsellIsScript) ? 'CELESTIC-SCRIPT'
    : (upsellContainer && upsellContainer.dataset.upsellIsTracksuit) ? 'CELESTIC-TRACKSUIT'
    : (upsellContainer && upsellContainer.dataset.upsellIsSummerset) ? 'CELESTIC-SUMMERSET'
    : 'CELESTIC-BUNDLE';

  function refreshAtcText() {
    const mainV = variants.find(function (x) { return x.id === selectedVariantId; });
    if (!mainV) return;
    var total = mainV.price;
    if (upsellEnabled && upsellVariantId) {
      if (upsellFixedPrice > 0) {
        total += upsellFixedPrice;
      } else {
        var upsellBtn = upsellSizesPanel && upsellSizesPanel.querySelector('[data-upsell-variant].is-active');
        if (upsellBtn) total += parseInt(upsellBtn.dataset.upsellPrice, 10);
      }
    }
    if (atcText) atcText.textContent = (mainV.available ? (IS_FI ? 'KASSALLE • ' : 'CHECKOUT • ') : (IS_FI ? 'Loppunut • ' : 'Sold out • ')) + formatMoney(total);
  }

  if (upsellToggle) {
    upsellToggle.addEventListener('change', function () {
      upsellEnabled = upsellToggle.checked;
      if (upsellSizesPanel) upsellSizesPanel.hidden = !upsellEnabled;
      if (!upsellEnabled) {
        upsellVariantId = null;
        if (upsellSizesPanel) {
          upsellSizesPanel.querySelectorAll('[data-upsell-variant]').forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          });
        }
      }
      refreshAtcText();
    });
  }

  if (upsellSizesPanel) {
    upsellSizesPanel.querySelectorAll('[data-upsell-variant]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        upsellSizesPanel.querySelectorAll('[data-upsell-variant]').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        upsellVariantId = parseInt(btn.dataset.upsellVariant, 10);
        refreshAtcText();
      });
    });
  }

  /* ---- AJAX Add to Cart — sama lähestymistapa kuin teeman celestic-atc-btn ---- */
  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      if (!selectedVariantId || atcBtn.disabled) return;

      if (upsellEnabled && !upsellVariantId) {
        if (upsellSizesPanel) {
          upsellSizesPanel.style.outline = '2px solid #c62828';
          upsellSizesPanel.style.borderRadius = '6px';
          setTimeout(function () {
            upsellSizesPanel.style.outline = '';
            upsellSizesPanel.style.borderRadius = '';
          }, 1800);
        }
        return;
      }

      atcBtn.classList.add('is-loading');
      atcBtn.disabled = true;
      if (atcSpinner) atcSpinner.hidden = false;

      const items = [{ id: selectedVariantId, quantity: 1 }];
      if (upsellEnabled && upsellVariantId) items.push({ id: upsellVariantId, quantity: 1 });

      var destUrl = (upsellEnabled && upsellVariantId && isBundleProduct)
        ? '/checkout?discount=' + encodeURIComponent(BUNDLE_DISCOUNT_CODE)
        : '/checkout';

      closeDrawer();
      var checkoutOverlay = document.getElementById('satc-checkout-overlay');
      if (checkoutOverlay) checkoutOverlay.classList.add('is-visible');

      // This flow bypasses the UpCart cart drawer, so its gift logic never runs. Add the items, check the
      // resulting cart subtotal, and add the free Mystery Gift when the order qualifies (>= 100€), then redirect.
      var GIFT = window.CELESTIC_GIFT_VARIANT || 60569088590158;
      var GIFT_THRESH = window.CELESTIC_GIFT_THRESHOLD || 10000;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function() {
        return fetch('/cart.js').then(function(r){ return r.json(); });
      }).then(function(cart) {
        var sub = 0;
        (cart.items || []).forEach(function(i){ if (i.variant_id !== GIFT) sub += i.final_line_price; });
        if (sub >= GIFT_THRESH) {
          return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id: GIFT, quantity: 1 }) });
        }
      }).then(function() {
        window.location = destUrl;
      }).catch(function() {
        window.location = destUrl;
      });
    });
  }

  /* ---- Sync variantti pääsivun valinnan kanssa ---- */
  document.addEventListener('variant:change', function (e) {
    const v = e.detail && e.detail.variant;
    if (!v) return;
    const priceStr = formatMoney(v.price);
    if (stickyPriceEl) stickyPriceEl.textContent = priceStr;
    if (drawerPriceEl) drawerPriceEl.textContent = priceStr;
    if (atcText) atcText.textContent = (v.available ? (IS_FI ? 'KASSALLE • ' : 'CHECKOUT • ') : (IS_FI ? 'Loppunut • ' : 'Sold out • ')) + priceStr;
    selectedVariantId = v.id;
    if (atcBtn) { atcBtn.dataset.variantId = v.id; atcBtn.disabled = !v.available; }

    if (v.options) {
      v.options.forEach(function (optValue, idx) {
        const grid = drawer.querySelectorAll('.satc-drawer__option-grid')[idx];
        if (!grid) return;
        grid.querySelectorAll('.satc-drawer__size-btn').forEach(function (b) {
          const active = b.dataset.optionValue === optValue;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    }
    refresh48hBadge();
  });

  /* ---- Countdown — evergreen daily timer, resets at midnight ---- */
  (function () {
    function getMidnight() {
      var d = new Date();
      d.setHours(23, 59, 59, 999);
      return d.getTime();
    }
    function pad(n) { return String(n).padStart(2, '0'); }
    var countdownEls = document.querySelectorAll('[data-sticky-countdown], [data-drawer-countdown]');
    var tickTimer = null;
    function tick() {
      var ms = getMidnight() - Date.now();
      if (ms < 0) ms = 0;
      var val = pad(Math.floor(ms / 3600000)) + ':' + pad(Math.floor((ms % 3600000) / 60000)) + ':' + pad(Math.floor((ms % 60000) / 1000));
      countdownEls.forEach(function (el) { el.textContent = val; });
      tickTimer = setTimeout(tick, 1000);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          if (!tickTimer) tick();
        } else {
          clearTimeout(tickTimer);
          tickTimer = null;
        }
      }, { threshold: 0 }).observe(stickyBar);
    } else {
      tick();
    }
  })();
})();
